export interface CertificationDto {
  code: string;
  description: string;
  skillTester: string;
  certDate: Date | string | null;
  expireDate: Date | string | null;
}

export interface SafetyAwarenessDto {
  description: string;
  skillTester: string;
  completeDate: Date | string | null;
  expireDate: Date | string | null;
}

export interface TrainingDto {
  description: string;
  skillTester: string;
  completeDate: Date | string | null;
  expireDate: Date | string | null;
}

/** Anonymous badge QR scan answer (Bug 36830): never SSN, HRRef or scores. */
export interface TrainingRecordResponseDto {
  employeeName: string;
  companyNo: number | null;
  profilePhotoFileId: string | null;
  certifications: CertificationDto[];
  safetyAwareness: SafetyAwarenessDto[];
  training: TrainingDto[];
}
